<template>
    <div class="mt-8 lg:mb-4">
      <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-2">Documentos de la notificación</h2>
      <div>
        <BaseAccessibleTable
          :rows="Adjuntos"
          :columns="tableColumns"
          :enableScroll="false"
          rowKey="idAdjunto"
          :theadClass="Adjuntos && Adjuntos.length > 0 ? '' : 'sr-only'"
        >
          <template #cell-actions="{ row }">
            <div class="flex flex-row">
              <base-button-icon
                v-if="row.icon === 'eye' || row.icon === 'eyeslash'"
                class="mr-2"
                @click="showAdjunto(row)"
                :name="row.icon"
                mode="core"
                :ariaLabel="row.icon === 'eye' ? 'Mostrar documento' : 'Ocultar documento'"
              />
              <base-button-icon
                @click="downloadAdjunto(row)"
                name="download"
                mode="core"
                ariaLabel="Descargar documento"
              />
            </div>
          </template>
        </BaseAccessibleTable>
      </div>
    </div>
</template>

<script>
import BaseAccessibleTable from '@/components/tables/BaseAccessibleTable.vue'

export default {
  name: 'table-element-adjuntos',
  props: {
    Adjuntos: {
      type: Array,
      default: () => []
    },
  },
  components: {
    BaseAccessibleTable,
  },
  data: function () {
    return {
    }
  },
  computed: {
    tableColumns () {
      return [
        { key: 'Nombre', label: 'Documento', minWidth: '200px', align: 'left' },
        { key: 'actions', label: 'Acciones', width: '120px', align: 'center' },
        { key: 'Extension', label: 'Extension', width: '90px', align: 'center' }
      ]
    }
  },
  methods: {
    showAdjunto (row) {
      this.$emit('showAdjunto', row)
    },
    downloadAdjunto (row) {
      this.$emit('downloadAdjunto', row)
    },
  },
}
</script>
